import { Toast } from 'primereact/toast';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  setConfigurationUsers,
  setConfigurationUsersAfterAzureSync,
  setCurrentUser,
} from '../../store/actions/proyectAction';
import LoaddingComponent from '../LoadingComponent';
import Activo from './Activo';
import ActualizarRol from './ActualizarRol';
import './Configuracion.scss';
import DiscoverGPMPlants from './DiscoverGPMPlants';
import PlantasUsuario from './PlantasUsuario';
import TablaUsuarios from './TablaUsuarios';

const Configuracion = ({
  setConfigurationUsers,
  setConfigurationUsersAfterAzureSync,
  users,
  currentUser,
  setCurrentUser,
  loading,
}) => {
  const toast = useRef(null);
  const { t } = useTranslation();
  useEffect(() => {
    setConfigurationUsers();
  }, [setConfigurationUsers]);

  return (
    <div className="configuracion">
      <Toast ref={toast} />
      <div className="p-grid">
        <div className="p-col-12">
          {loading ? (
            <div className="spinner">
              <LoaddingComponent />
            </div>
          ) : (
            <>
              <div className="p-col-12 p-md-7 floatLeft margin5">
                <div className="card p-col-12">
                  {true ? (
                    <TablaUsuarios
                      users={users}
                      setConfigurationUsersAfterAzureSync={
                        setConfigurationUsersAfterAzureSync
                      }
                      setCurrentUser={setCurrentUser}
                    />
                  ) : (
                    <div className="">Sin datos</div>
                  )}
                </div>

                <div className="card p-col-12">
                  <h3 className="margingtop10 p-col-12">
                    {t('Configuración general de plantas')}
                  </h3>
                  <DiscoverGPMPlants />
                </div>
              </div>

              <div className="p-col-12 p-md-4 floatLeft margin5 margingtop10">
                <div className="p-grid">
                  <div className="card p-col-12 floatLeft">
                    <ActualizarRol
                      toast={toast}
                      t={t}
                      currentUser={currentUser}
                    />
                  </div>
                  <div
                    className="card p-col-12 floatLeft"
                    style={{ padding: '27px' }}
                  >
                    <Activo currentUser={currentUser} t={t} toast={toast} />
                    <PlantasUsuario currentUser={currentUser} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = rootReducer => ({
  users: rootReducer.proyect.configuration.users || [],
  currentUser: rootReducer.proyect.configuration.currentUser,
  loading: rootReducer.proyect.configuration.loading,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setConfigurationUsers,
      setConfigurationUsersAfterAzureSync,
      setCurrentUser,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Configuracion);
